import { formatDate } from "@fullcalendar/core";
import React from "react";
import localeText from "../../../../../locale";
import { useLocation, useHistory } from "react-router-dom";
import replyIcon from "../../../../images/pages/corner-down-right.svg";

const breakWordStyle = {
  overflowWrap: "break-word",
  wordBreak: "break-word",
};

const Question = ({
  firstName,
  question,
  dateQuestion,
  onwerProduct,
  questionId,
  answer,
  dateAnswer,
  productOwnerFirstName,
}) => {
  const history = useHistory();
  const url = useLocation();
  const params = new URLSearchParams(url?.search);
  const isOwnerProduct = onwerProduct === localStorage.getItem("__extraconomy_username");

  const handleQuestion = () => {
    params.append("questionId", questionId);
    history.push(`${url.pathname}?${params?.toString()}`);
  };

  return (
    <div
      className={`flex flex-column w-full mb-3 ${answer ? "gap-3" : "gap-1"}`}
      style={{ maxWidth: "650px" }}
    >
      {/*  <p className="mb-0">
        <strong>{firstName}</strong> - {formatDate(dateQuestion)}
      </p> */}
      <div className="font-medium text-sm" style={{ color: "#091E42", ...breakWordStyle }}>
        {question}
      </div>
      {answer && (
        <div className="flex gap-2 ml-1 align-items-start">
          <img src={replyIcon} alt="reply" />
          <div>
            {/*  <p className="mb-0">
              <strong>{productOwnerFirstName}</strong> - {formatDate(dateAnswer)}
            </p> */}
            <span className="font-medium text-xs" style={{ color: "#505F79", ...breakWordStyle }}>
              {answer}
            </span>
          </div>
        </div>
      )}
      {!answer && !isOwnerProduct && (
        <div
          className="font-medium text-xs font-italic"
          style={{ color: "#505F79", ...breakWordStyle }}
        >
          {localeText("waitingResponseFromSeller")}
        </div>
      )}
      {isOwnerProduct && !answer && (
        <div
          className="text-gray-600 hover:text-gray-800 underline cursor-pointer inline-block text-xs"
          onClick={handleQuestion}
        >
          {localeText("reply")}
        </div>
      )}
    </div>
  );
};

export default Question;
